var map = {
	"./brands/beeBet": 2587,
	"./brands/beeBet.json": 2587,
	"./brands/betfred": 1496,
	"./brands/betfred.json": 1496,
	"./brands/betmgm": 5883,
	"./brands/betmgm.json": 5883,
	"./brands/entain": 6690,
	"./brands/entain.json": 6690,
	"./brands/esportesDaSorte": 6046,
	"./brands/esportesDaSorte.json": 6046,
	"./brands/estrelaBet": 4558,
	"./brands/estrelaBet.json": 4558,
	"./brands/everi": 6941,
	"./brands/everi.json": 6941,
	"./brands/fanduel": 7841,
	"./brands/fanduel.json": 7841,
	"./brands/jogoGames": 9720,
	"./brands/jogoGames.json": 9720,
	"./brands/novibet": 4381,
	"./brands/novibet.json": 4381,
	"./brands/others": 7757,
	"./brands/others.json": 7757,
	"./estrelabet/jogoGames/estrelabet-cert": 5162,
	"./estrelabet/jogoGames/estrelabet-cert.json": 5162,
	"./jogoglobal2/estrelaBet/estrelaBet": 6999,
	"./jogoglobal2/estrelaBet/estrelaBet.json": 6999,
	"./jogoglobal2/jogoGames/jogoGames": 1848,
	"./jogoglobal2/jogoGames/jogoGames.json": 1848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6482;